export default __webpack_public_path__ + "caa48cecabf72cae69428a13ed9b20a4.png";